import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const CANDLE_PATTERNS = new Set(['doji', 'hammer', 'shooting_star', 'pin_bar', 'bullish_engulfing', 'bearish_engulfing', 'inside_bar']);

export default function PatternNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const isCandlePattern = CANDLE_PATTERNS.has(data.pattern || 'head_and_shoulders');

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #7c3aed',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#a78bfa' }}>
        🔷 Chart Pattern
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select
        value={data.pattern || 'head_and_shoulders'}
        onChange={(e) => onChange('pattern', e.target.value)}
        style={{ width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        <option value="head_and_shoulders">Head &amp; Shoulders</option>
        <option value="double_top">Double Top</option>
        <option value="double_bottom">Double Bottom</option>
        <option value="doji">Doji</option>
        <option value="hammer">Hammer</option>
        <option value="shooting_star">Shooting Star</option>
        <option value="pin_bar">Pin Bar</option>
        <option value="bullish_engulfing">Bullish Engulfing</option>
        <option value="bearish_engulfing">Bearish Engulfing</option>
        <option value="inside_bar">Inside Bar</option>
      </select>

      {!isCandlePattern && (
        <select
          value={data.confirmation || 'neckline_break'}
          onChange={(e) => onChange('confirmation', e.target.value)}
          style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="neckline_break">Neckline Break</option>
          <option value="breakout">Breakout</option>
          <option value="strict">Strict Match</option>
        </select>
      )}

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)' }}>
        {isCandlePattern
          ? 'Single/two-bar candlestick pattern. Outputs 1 when detected, otherwise 0.'
          : 'Multi-bar chart pattern. Outputs 1 when detected, otherwise 0.'}
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#7c3aed' }} />
    </div>
  );
}
